function k1CollectionLocaleText(key) {
  if (window.K1Text) {
    return window.K1Text(key, key);
  }

  const isEnglish = document.documentElement.lang === 'en' || window.location.pathname.startsWith('/en/');
  const map = {
    addToCart: isEnglish ? 'Add to cart' : 'カートに追加',
    soldOut: isEnglish ? 'Sold out' : '売り切れ',
    adding: isEnglish ? 'Adding...' : '追加中...',
    stockLimit: isEnglish ? 'Quantity cannot exceed available stock.' : '在庫数を超える数量は選択できません。',
    inStock: isEnglish ? 'In stock' : '在庫あり',
    outOfStock: isEnglish ? 'Out of stock' : '在庫なし',
    category: isEnglish ? 'Category' : 'カテゴリ',
    currentCart: isEnglish ? 'Current cart' : 'カート',
    cartEmpty: isEnglish ? 'Your cart is empty' : 'カートは空です',
    stockLabel: isEnglish ? 'Stock:' : '在庫数：',
    inCart: isEnglish ? 'In cart' : 'カート内',
    emptyCollection: isEnglish ? 'This collection has no products.' : 'このコレクションには商品がありません。',
  };
  return map[key] || key;
}

document.addEventListener("DOMContentLoaded", function () {
  const minusBtns = document.querySelectorAll(".qty-btn.minus");
  const plusBtns = document.querySelectorAll(".qty-btn.plus");
  const qtyInputs = document.querySelectorAll(".qty-input-box");

  minusBtns.forEach((minusBtn, index) => {
    minusBtn.addEventListener("click", function () {
      let currentValue = parseInt(qtyInputs[index].value);
      if (currentValue > parseInt(qtyInputs[index].min)) {
        qtyInputs[index].value = currentValue - 1;
      }
    });
  });

  plusBtns.forEach((plusBtn, index) => {
    plusBtn.addEventListener("click", function () {
      let currentValue = parseInt(qtyInputs[index].value);
      if (currentValue < parseInt(qtyInputs[index].max)) {
        qtyInputs[index].value = currentValue + 1;
      }
    });
  });

  // Add event listeners for add to cart forms
  initializeAddToCartForms();

  document.addEventListener("change", function (event) {
    const selector = event.target.closest(".collection-variant-selector");
    if (!selector) return;

    const option = selector.selectedOptions[0];
    const card = selector.closest(".collection-product-card");
    if (!option || !card) return;

    const currentPrice = card.querySelector(".collection-product-current-price");
    const comparePrice = card.querySelector(".collection-product-compare-price");
    const inventoryQty = card.querySelector(".inventory-qty");
    const realQty = card.querySelector(".real-qty");
    const qtyInput = card.querySelector(".qty-input-box");
    const qtyButtons = card.querySelectorAll(".qty-btn");
    const cartButton = card.querySelector(".CartBtn");
    const onSale = option.dataset.onSale === "true";
    const available = option.dataset.available === "true";

    if (currentPrice) {
      currentPrice.textContent = option.dataset.price;
      currentPrice.dataset.onSale = onSale ? "true" : "false";
    }
    if (comparePrice) {
      comparePrice.textContent = option.dataset.comparePrice;
      comparePrice.hidden = !onSale;
    }
    if (inventoryQty) inventoryQty.textContent = option.dataset.inventory;
    if (realQty) realQty.textContent = option.dataset.realQty;
    if (qtyInput) {
      qtyInput.max = option.dataset.realQty;
      qtyInput.value = Math.min(Math.max(parseInt(qtyInput.value) || 1, 1), parseInt(option.dataset.realQty) || 1);
      qtyInput.disabled = !available;
    }
    qtyButtons.forEach((button) => {
      button.disabled = !available;
    });
    if (cartButton) {
      cartButton.dataset.quantity = option.dataset.realQty;
      cartButton.disabled = !available;
      const buttonText = cartButton.querySelector(".cartbtn-text");
      if (buttonText) buttonText.textContent = available ? k1CollectionLocaleText("addToCart") : k1CollectionLocaleText("soldOut");
    }

    document.dispatchEvent(
      new CustomEvent("collection:variant-change", {
        detail: { card, variantId: option.value },
      }),
    );
  });
});

function preventZoom(event) {
  event.preventDefault();
}

function initializeAddToCartForms() {
  // Select all add to cart forms with comprehensive selectors
  const addToCartForms = document.querySelectorAll('form[action*="/cart/add"], form.product-form, .collection-product-card form, .product-card form, form[action="/cart/add"]');
  
  addToCartForms.forEach((form, index) => {
    // Check if we already added our custom listener
    if (form.hasAttribute('data-custom-cart-listener')) {
      return; // Skip if already processed
    }
    // Mark this form as processed
    form.setAttribute('data-custom-cart-listener', 'true');
    
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      
      // Double check to avoid multiple submissions
      if (form.hasAttribute('data-submitting')) {
        return;
      }
      form.setAttribute('data-submitting', 'true');
      
      const qtyInput = form.querySelector(".qty-input-box");
      const quantity = qtyInput ? parseInt(qtyInput.value) : 1;

      // Check if quantity entered is greater than available quantity
      let currentRealQty = null;
      let realQtyElement = null;
      const card = form.closest(".collection-product-card");
      if (card) {
        realQtyElement = card.querySelector(".real-qty");
        if (realQtyElement) {
          currentRealQty = parseInt(realQtyElement.textContent);
        }
      }

      if (currentRealQty !== null && quantity > currentRealQty) {
        alert(k1CollectionLocaleText("stockLimit"));
        form.removeAttribute('data-submitting');
        return false;
      }

      // Change button text while the item is being added.
      const cartBtnText = form.querySelector(".cartbtn-text");
      if (cartBtnText) cartBtnText.textContent = k1CollectionLocaleText("adding");

      const formData = new FormData(form);
      formData.append("quantity", quantity);
      
      try {
        const res = await fetch("/cart/add", {
          method: "POST",
          body: formData,
        });
        
        if (res.ok) {
          // Update real-qty
          if (realQtyElement && currentRealQty !== null) {
            realQtyElement.textContent = currentRealQty - quantity;
          }

          // Update cart drawer (this will handle cart counts and loading animation)
          await window.StickyCart.updateCartDrawer();
          
          // Re-initialize add to cart forms in case new forms were loaded
          initializeAddToCartForms();

          if (cartBtnText) cartBtnText.textContent = k1CollectionLocaleText("addToCart");
        } else {
          const errorData = await res.json();
          if (cartBtnText) cartBtnText.textContent = k1CollectionLocaleText("addToCart");
        }
      } catch (err) {
        console.error("Fetch error:", err);
        if (cartBtnText) cartBtnText.textContent = k1CollectionLocaleText("addToCart");
      } finally {
        // Always remove the submitting flag
        form.removeAttribute('data-submitting');
      }
    });
  });
}

// Make initializeAddToCartForms available globally for sticky-cart.js
window.initializeAddToCartForms = initializeAddToCartForms;

document.addEventListener('DOMContentLoaded', function() {
    var labels = document.querySelectorAll('label[for^="Filter-"]');
    labels.forEach(function(label) {
        if (label.htmlFor.includes('availability-1')) {
            label.innerHTML = label.innerHTML.replace('In stock', k1CollectionLocaleText('inStock'));
        } else if (label.htmlFor.includes('availability-2')) {
            label.innerHTML = label.innerHTML.replace('Out of stock', k1CollectionLocaleText('outOfStock'));
        }
    });
});